import React from 'react';

import Stage1 from '../components/stages/Stage1';
import Stage2 from '../components/stages/Stage2';
import Stage3 from '../components/stages/Stage3';
import Stage4 from '../components/stages/Stage4';
import Stage5 from '../components/stages/Stage5';
import Stage6 from '../components/stages/Stage6';
import Stage7 from '../components/stages/Stage7';
import Stage8 from '../components/stages/Stage8';
import Stage9 from '../components/stages/Stage9';
import Stage10 from '../components/stages/Stage10';
import Stage11 from '../components/stages/Stage11';
import Stage12 from '../components/stages/Stage12';
import UnsuccessfulStage from '../components/stages/UnsuccessfulStage';

import {
  updateBrandSizes,
  finalAdjustment,
  updatedCupSize,
  updateCup,
  updateBack,
  updatedBackSize,
  convertFromUSToUKSize,
} from './helpers';
import { sizeQuizMessages as messages } from '../data/messages';

export const stagesCompiler = ({
  backChange,
  backSize,
  backSizes,
  basePath,
  buttonSelected,
  cachedCupSize,
  contactData,
  country,
  countrySizes,
  cupChange,
  cupSize,
  cupSizes,
  defaultButtonProps,
  defaultNextProps,
  defaultPreviousProps,
  displayQuiz,
  partTwoButtonSelected,
  resetAllChanges,
  resetBackAndCup,
  resetCup,
  resetSizeAndCaches,
  setBackSize,
  setBackSizes,
  setBackChange,
  setCachedBackSize,
  setCachedCupSize,
  setCupChange,
  setCupSize,
  setCupSizes,
  setNextStage,
  setPartTwoSelected,
  setSelected,
  setTempBackCache,
  setTempCupCache,
  showPartTwo,
  stageButtonData,
  tempBackCache,
  tempCupCache,
  toggleCountry,
  togglePartTwo,
}) => {
  const {
    stage5Data,
    stage7aData,
    stage7bData,
    stage8Data,
    stage9aData,
    stage9bData,
    stage10aData,
    stage10bData,
  } = stageButtonData;

  return [
    <Stage1
      buttonSelected={buttonSelected}
      defaultNextProps={defaultNextProps}
      messages={messages}
      setBackChange={setBackChange}
      setCupChange={setCupChange}
      setSelected={setSelected}
      updateBrandSizes={updateBrandSizes}
    />,
    <Stage2
      backChange={backChange}
      backSize={backSize}
      backSizes={backSizes}
      country={country}
      countrySizes={countrySizes}
      cupChange={cupChange}
      cupSize={cupSize}
      cupSizes={cupSizes}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
      resetSizeAndCaches={resetSizeAndCaches}
      setBackSize={setBackSize}
      setBackSizes={setBackSizes}
      setBackChange={setBackChange}
      setCupChange={setCupChange}
      setCupSize={setCupSize}
      setCupSizes={setCupSizes}
      setTempBackCache={setTempBackCache}
      setTempCupCache={setTempCupCache}
      tempBackCache={tempBackCache}
      tempCupCache={tempCupCache}
      toggleCountry={toggleCountry}
      updateBack={updateBack}
      updatedBackSize={updatedBackSize}
      updateCup={updateCup}
      updatedCupSize={updatedCupSize}
    />,
    <Stage3
      buttonSelected={buttonSelected}
      defaultButtonProps={defaultButtonProps}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
      resetSizeAndCaches={resetSizeAndCaches}
    />,
    <Stage4
      buttonSelected={buttonSelected}
      defaultButtonProps={defaultButtonProps}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
    />,
    <Stage5
      buttonSelected={buttonSelected}
      defaultButtonProps={defaultButtonProps}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
      resetBackAndCup={resetBackAndCup}
      stage5Data={stage5Data}
    />,
    <Stage6
      backSize={backSize}
      cupSize={cupSize}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
      resetSizeAndCaches={resetSizeAndCaches}
      setCachedBackSize={setCachedBackSize}
      setCachedCupSize={setCachedCupSize}
      setTempCupCache={setTempCupCache}
    />,
    <Stage7
      buttonSelected={buttonSelected}
      defaultButtonProps={defaultButtonProps}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
      partTwoButtonSelected={partTwoButtonSelected}
      setPartTwoSelected={setPartTwoSelected}
      stage7aData={stage7aData}
      showPartTwo={showPartTwo}
      stage7bData={stage7bData}
      resetCup={resetCup}
      cupSize={cupSize}
      cupChange={cupChange}
      setTempCupCache={setTempCupCache}
      cachedCupSize={cachedCupSize}
    />,
    <Stage8
      buttonSelected={buttonSelected}
      cachedCupSize={cachedCupSize}
      cupChange={cupChange}
      cupSize={cupSize}
      defaultButtonProps={defaultButtonProps}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
      resetCup={resetCup}
      setTempCupCache={setTempCupCache}
      stage8Data={stage8Data}
    />,
    <Stage9
      buttonSelected={buttonSelected}
      cachedCupSize={cachedCupSize}
      cupChange={cupChange}
      cupSize={cupSize}
      defaultButtonProps={defaultButtonProps}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
      partTwoButtonSelected={partTwoButtonSelected}
      resetCup={resetCup}
      setPartTwoSelected={setPartTwoSelected}
      setTempCupCache={setTempCupCache}
      showPartTwo={showPartTwo}
      stage9aData={stage9aData}
      stage9bData={stage9bData}
      togglePartTwo={togglePartTwo}
    />,
    <Stage10
      backSize={backSize}
      buttonSelected={buttonSelected}
      cachedCupSize={cachedCupSize}
      cupSize={cupSize}
      defaultButtonProps={defaultButtonProps}
      defaultNextProps={defaultNextProps}
      defaultPreviousProps={defaultPreviousProps}
      messages={messages}
      partTwoButtonSelected={partTwoButtonSelected}
      resetCup={resetCup}
      setNextStage={setNextStage}
      setPartTwoSelected={setPartTwoSelected}
      setTempCupCache={setTempCupCache}
      showPartTwo={showPartTwo}
      stage10aData={stage10aData}
      stage10bData={stage10bData}
      togglePartTwo={togglePartTwo}
    />,
    <Stage11
      backChange={backChange}
      backSize={backSize}
      country={country}
      cupChange={cupChange}
      cachedCupSize={cachedCupSize}
      cupSize={cupSize}
      defaultPreviousProps={defaultPreviousProps}
      defaultNextProps={defaultNextProps}
      messages={messages}
      resetCup={resetCup}
      setPartTwoSelected={setPartTwoSelected}
      setTempCupCache={setTempCupCache}
      togglePartTwo={togglePartTwo}
      setNextStage={setNextStage}
      finalAdjustment={finalAdjustment}
      convertFromUSToUKSize={convertFromUSToUKSize}
    />,
    <Stage12
      backChange={backChange}
      backSize={backSize}
      basePath={basePath}
      contactData={contactData}
      country={country}
      cupChange={cupChange}
      cupSize={cupSize}
      defaultNextProps={defaultNextProps}
      finalAdjustment={finalAdjustment}
      messages={messages}
      resetAllChanges={resetAllChanges}
      displayQuiz={displayQuiz}
      convertFromUSToUKSize={convertFromUSToUKSize}
    />,
    <UnsuccessfulStage
      contactData={contactData}
      messages={messages}
      displayQuiz={displayQuiz}
    />,
  ];
};
